import '../sass/faqs-block.scss';
import './faqs-block';
